export default __webpack_public_path__ + "static/media/spt2.8b5382df.png";